import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import { type Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    background: COLORS.WHITE,
    height: '100%',
    position: 'fixed',
    width: '100%',
    zIndex: 10,
  },
  image: {
    background: 'transparent center/100% url("/img/loading.png") no-repeat',
    height: '60%',
    margin: 'auto',
    width: '25%',

    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
  },
  text: {
    fontSize: 40,
    marginLeft: '15%',
    paddingTop: '5%',

    [theme.breakpoints.down('md')]: {
      fontSize: 25,
    },
  },
}), { name: 'LoadingPage' });

const LoadingPage = (): JSX.Element => {
  const [numberOfDots, setNumberOfDots] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => {
      if (numberOfDots === 3) {
        setNumberOfDots(0);
      } else {
        setNumberOfDots(numberOfDots + 1);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [numberOfDots, setNumberOfDots]);

  const dotsText = '.'.repeat(numberOfDots);

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.text}>
        <FormattedMessage id="loading" />
        <span id="loading-text-dots">{dotsText}</span>
      </div>

      <div className={classes.image} />
    </div>
  );
};

export default LoadingPage;
